// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"8efb4111","239":"c605fe2a","453":"ec973aba","455":"7899611e","619":"5ce81e27","749":"cf7609e7","903":"6c8a4da4","977":"ad938641"}[chunkId] + ".chunk.js";
};